"use client";

import ModalOrchestrator from "@/video-lab/modal-orchestrator";
import { useUserRecognition } from "hooks/useRecognizedUserData";

// WAT-10279: Priority list is sorted in SSR (both routers) and passed in
// pre-sorted. The client wrapper only layers in user-recognition state.
export function ModalOrchestratorClient(props) {
  const userRecognitionData = useUserRecognition({
    initialRecognizedUserData: props?.initialRecognizedUserData,
    isUserAuthenticated: props?.isUserAuthenticated
  });

  return (
    <ModalOrchestrator
      {...props}
      clientSideIsUserAuth={userRecognitionData.clientSideIsUserAuthenticated}
    />
  );
}

export default ModalOrchestratorClient;
